var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import classNames from 'classnames';
import { produce } from 'immer';
import { startCase } from 'lodash';
import React, { useRef, useState } from 'react';
import { searchViewingRights } from '../../Async/MedicationsSummaryAsync';
import { createProblemByAuthKey, searchProblemsByAuthKey } from '../../Async/ProblemsAsync';
import { FormikStyledSelectAsync } from '../../Components/FormikFields/FormikStyledSelectAsync';
import { PlusIcon, RoundedFolderIcon } from '../../Components/Icons';
import { useField } from '../../Components/useForm/useField';
import { displayError, displayMessage } from '../../Config/ApplicationConfig';
import { defaultAuthoringSystem, selfAuthoringSystemForeignKey } from '../../Shared/Constants';
import { getFirstErrorMessageFromApiError } from '../../Shared/DomainValidationFunctions';
import { lookupIdentifierToKey, lookupIdentifierToName, referenceToKey, referenceToString } from '../../Shared/SharedModels';
import { primary, white } from '../../Styles/Colours';
import styles from './EditMedicationProblemsAndViewingRights.module.css';
export var Fields;
(function (Fields) {
    Fields["Name"] = "Name";
    Fields["Date"] = "Date";
    Fields["Time"] = "Time";
    Fields["ViewingRight"] = "ViewingRight";
})(Fields || (Fields = {}));
var newProblemButton = function (searchText) {
    if (!searchText)
        return null;
    return (React.createElement("div", { className: styles.externalWitnessItem },
        React.createElement(PlusIcon, { color: primary, size: '24', noPadding: true }),
        React.createElement("span", { className: styles.externalWitnessActionText }, "Record external witness")));
};
export function EditMedicationProblemsAndViewingRights(props) {
    var _a, _b, _c;
    var _this = this;
    var viewingRightInput = useRef(null);
    var _d = __read(useState(false), 2), creatingNewProblem = _d[0], setCreatingNewProblem = _d[1];
    var focusViewingRights = function () {
        if (props.readOnly)
            return;
    };
    var blueViewingRights = function () {
        if (props.readOnly)
            return;
    };
    var problemsAndViewingRightsClasses = classNames(styles.problemsAndViewingRights, (_a = {},
        _a[styles.problemsAndViewingRightsReadOnly] = props.readOnly,
        _a));
    var viewingRightContainerClasses = classNames(styles.viewingRightContainer, (_b = {},
        _b[styles.readOnly] = props.readOnly,
        _b));
    var problemsField = useField({ form: props.form, field: 'problems' });
    var getProblems = function (config, query) {
        if (query === void 0) { query = ''; }
        return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, searchProblemsByAuthKey(config, props.patient.authoringSystem, props.patient.authoringSystemForeignKey, query, 5)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    var createNewProblem = function (name) { return __awaiter(_this, void 0, void 0, function () {
        var defaultViewingRight, problemName, createProblemData, result, newProblem_1, currentProblems, newProblems, e_1, firstError;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (creatingNewProblem)
                        return [2 /*return*/];
                    setCreatingNewProblem(true);
                    defaultViewingRight = props.getDefaultViewingRight();
                    if (defaultViewingRight === null) {
                        displayError('No viewing right set');
                        return [2 /*return*/];
                    }
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    problemName = startCase(name.toLowerCase()).trim();
                    createProblemData = {
                        name: problemName,
                        viewingRight: defaultViewingRight,
                        isActive: true,
                        authoringSystem: defaultAuthoringSystem,
                        authoringSystemForeignKey: selfAuthoringSystemForeignKey
                    };
                    return [4 /*yield*/, createProblemByAuthKey(props.patient.authoringSystem, props.patient.authoringSystemForeignKey, createProblemData)];
                case 2:
                    result = _a.sent();
                    newProblem_1 = {
                        id: result.id,
                        authoringSystemForeignKey: '',
                        authoringSystem: '',
                        name: problemName
                    };
                    currentProblems = problemsField.value;
                    newProblems = produce(currentProblems, function (draft) {
                        draft.push(newProblem_1);
                    });
                    problemsField.setValue(newProblems);
                    displayMessage('Problem created');
                    setCreatingNewProblem(false);
                    return [3 /*break*/, 4];
                case 3:
                    e_1 = _a.sent();
                    firstError = getFirstErrorMessageFromApiError(e_1);
                    displayError(firstError);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var problemSelectorClasses = classNames(styles.problemSelectorContainer, (_c = {},
        _c[styles.viewingRightsShown] = !props.hideViewingRights,
        _c));
    return (React.createElement("div", { className: problemsAndViewingRightsClasses },
        !props.hideProblems && (React.createElement("div", { className: styles.problems },
            React.createElement("span", { className: styles.problemLabel }, "Problems"),
            React.createElement("div", { className: problemSelectorClasses },
                React.createElement(FormikStyledSelectAsync, { isClearable: false, emptyValue: [], isMulti: true, name: 'problems', testId: 'problems', fetch: getProblems, label: '', getMultiValueChipIcon: function () { return (React.createElement(RoundedFolderIcon, { size: '24', backgroundColour: primary, color: white })); }, itemToMenuKey: lookupIdentifierToKey, itemToString: lookupIdentifierToName, additionalActionButton: {
                        render: newProblemButton,
                        onSelection: createNewProblem,
                        displayText: function () { return 'new'; }
                    }, maxResults: 5, readOnly: props.readOnly })))),
        !props.hideViewingRights && (React.createElement("div", { className: viewingRightContainerClasses },
            React.createElement("span", { className: styles.viewingRightLabel }, "Viewing rights"),
            React.createElement("div", { className: props.readOnly ? styles.viewRightSelectorReadOnly : styles.viewRightSelector },
                React.createElement(FormikStyledSelectAsync, { maxResults: 5, name: 'viewingRight', label: '', itemToString: referenceToString, itemToMenuKey: referenceToKey, fetch: searchViewingRights, selectRef: function (e) {
                        viewingRightInput.current = e;
                    }, onFocus: focusViewingRights, onClick: focusViewingRights, onBlur: blueViewingRights, readOnly: props.readOnly, isClearable: true, testId: 'selection-input-viewing-right' }))))));
}
